module.exports = __webpack_public_path__ + "img/Voucher Not Valid.9491f448.png";